export const WORK_TYPES = [
  "Rénovation complète",
  "Extension / annexe",
  "Gros-œuvre & maçonnerie",
  "Toiture",
  "Châssis & menuiseries",
  "Isolation & façade",
  "Plafonnage & peinture",
  "Chapes & carrelage",
  "Électricité",
  "Plomberie & sanitaire",
  "Chauffage",
  "Terrassement & abords",
  "Dépannage urgent",
  "Autre",
];

export const COMMUNES = [
  "Anderlecht", "Auderghem", "Berchem-Sainte-Agathe", "Bruxelles-Ville", "Etterbeek", "Evere", "Forest",
  "Ganshoren", "Ixelles", "Jette", "Koekelberg", "Molenbeek-Saint-Jean", "Saint-Gilles", "Saint-Josse-ten-Noode",
  "Schaerbeek", "Uccle", "Watermael-Boitsfort", "Woluwe-Saint-Lambert", "Woluwe-Saint-Pierre",
  "Asse", "Dilbeek", "Grimbergen", "Hal", "Leuven", "Overijse", "Sint-Pieters-Leeuw", "Tervuren", "Vilvorde", "Zaventem",
  "Braine-l'Alleud", "La Hulpe", "Nivelles", "Ottignies-Louvain-la-Neuve", "Rebecq", "Tubize", "Waterloo", "Wavre",
  "Autre commune",
];

export const START_TIMELINES = ["Dès que possible", "Dans 1 à 3 mois", "Dans 3 à 6 mois", "Plus tard"];

export const SURFACES = ["Moins de 20 m²", "20-50 m²", "50-100 m²", "100-200 m²", "Plus de 200 m²"];

export const CTA_DEVIS = "Devis gratuit – réponse sous 48 h";
export const FACEBOOK_URL = "https://www.facebook.com/p/VGI-Construct-100091561347124/";
export const GOOGLE_REVIEWS_URL = "https://share.google/JhdVDoSejsS02z6tf";

export const REVIEWS = [
  { name: "Léon Serugendo", text: "J’ai fait appel à VGI Construct pour des travaux d’électricité, et je suis extrêmement satisfait du résultat. L’équipe est professionnelle, ponctuelle et très compétente. Le travail a été réalisé avec soin et dans les délais convenus. Une entreprise sérieuse que je recommande sans hésitation pour tout type de travaux électriques. Merci Daniel" },
  { name: "Alexia Lamarche", text: "Équipe très professionnelle, la gentillesse et la correction en prime. Nettoyage de chantier, flexibilité, rapidité et soucis du détail. Je hésiterai pas à refaire appel à Daniel et son équipe si nécessaire 👍" },
  { name: "Christophe Kabacinski", text: "Je recommande vivement VGI Construct. Ils sont venus travailler chez moi durant 1 mois pour refaire la cuisine, un couloir, SDB et travaux extérieurs. Travail impeccable, délais respectés, ponctuels, sympathiques et de bons conseils. Leur devis est très détaillé et complet et leur prix largement en dessous de leurs concurrents." },
  { name: "Pascal Hendrickx", text: "Travaux exécutés parfaitement. Nous sommes tres contents pour la qualité du travail, c'est soigné. Quand l'equipe quitte le chantier, tout est propre et rangé. Nous ne pouvons que recommander cet entrepreneur. Le devis est bien détaillé et nous n'avons pas eu de mauvaise surprise au niveau de la facture!." },
  { name: "Marine Santantonio", text: "Nous avons fait appel à Daniel pour la rénovation de notre maison : équipe très professionnelle, ponctuelle et travail réalisé avec minutie ! Très à l’écoute du client et chantier fini dans les temps ! À recommander les yeux fermés !" },
];
